import { render, staticRenderFns } from "./CRMenu.vue?vue&type=template&id=50727fef&scoped=true"
import script from "./CRMenu.vue?vue&type=script&lang=js"
export * from "./CRMenu.vue?vue&type=script&lang=js"
import style0 from "./CRMenu.vue?vue&type=style&index=0&id=50727fef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50727fef",
  null
  
)

export default component.exports